<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header>{{ 'tytul.podatki-zus' | translate }}</nb-card-header>
      <nb-card-body>
        <section >
          <span>{{ 'akcja.wybierz-okres' | translate }}:</span>
        </section>
        <section class="mt-2 ml-3">
          <ngx-zakres-dat (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
        </section>

        <nb-tabset (changeTab)="onChangeTab($event)">
          <nb-tab tabTitle="{{ 'zakladka.razem' | translate }}">
            <ngx-zus-podatki-tabela [dane]="razem" [zakresDat]="zakresDat"></ngx-zus-podatki-tabela>
          </nb-tab>
          <nb-tab tabTitle="{{ 'zakladka.wlasciciele' | translate }}">
            <ngx-zus-podatki-tabela [dane]="wlasciciele" [zakresDat]="zakresDat"></ngx-zus-podatki-tabela>
          </nb-tab>
          <nb-tab tabTitle="{{ 'zakladka.pracownicy' | translate }}">
            <ngx-zus-podatki-tabela [dane]="pracownicy" [zakresDat]="zakresDat"></ngx-zus-podatki-tabela>
          </nb-tab>
        </nb-tabset>
      </nb-card-body>
    </nb-card>
  </div>
</div>
